import { GovernanceCalendarDay } from '@/hooks/content/hooks/useGovernanceCalendar';
import { format } from 'date-fns';

export const GovernanceCalendarItem = ({ eventName, date, color }: GovernanceCalendarDay) => {
  const dayOfWeek = format(date, 'EE');
  const dayOfMonth = format(date, 'd');
  const time = format(date, 'HH:mm');

  return (
    <div
      className="flex flex-row items-center py-1 pr-3 border-left border-l-2 bg-neutral-950 gap-x-2 w-full"
      style={{ borderColor: color }}
    >
      <div className="flex flex-col items-center px-2 font-bold">
        <p className="uppercase">{dayOfWeek}</p>
        <p className="text-2xl">{dayOfMonth}</p>
      </div>
      <div className="flex flex-col gap-y-2">
        <p className="text-white font-semibold text-nowrap font-sans">{eventName}</p>
        <p className="text-sm text-grey-400 font-bold">{time} UTC</p>
      </div>
    </div>
  );
};
